module.exports = __webpack_public_path__ + "img/quotes.779f6466.svg";